var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "email-consult-editor",
      on: {
        dragover: function($event) {
          $event.preventDefault()
          return _vm.handleDragOver($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "email-consult-editor__wrapper" },
        [
          _c("CompassAvatar", {
            attrs: {
              size: "small",
              initials: _vm.currentUserInitials,
              avatarColorType: _vm.avatarColor(_vm.currentUserFullName)
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "email-consult-editor__panel" },
            [
              _c(
                "div",
                { staticClass: "email-consult-editor__panel-header" },
                [
                  _c("EmailRecipientsInputs", {
                    staticClass: "email-recipients-inputs",
                    attrs: {
                      hashPanel: _vm.hashPanel,
                      recipients: _vm.recipients
                    },
                    on: { updateAddressesEmails: _vm.onUpdateAddressesEmails }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLinkedObjectExist
                ? _c("EmailRelatedObject", {
                    attrs: { object: _vm.thread[0].linked_object }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("RichText", {
                ref: "refEmailPanelRichText",
                staticClass: "email-richtext",
                attrs: {
                  options: _vm.optionsRichText,
                  isCustom: true,
                  showRichTextMenu: false,
                  showAIComponents: _vm.showAIComponents,
                  typeRichText: "email",
                  hash: _vm.hash
                },
                on: {
                  focus: function($event) {
                    _vm.isEditorFocused = true
                  },
                  blur: function($event) {
                    _vm.isEditorFocused = false
                  }
                },
                scopedSlots: _vm._u(
                  [
                    _vm.isDragging
                      ? {
                          key: "drag-handle",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "drag-text typographies-paragraph-large-bold",
                                  on: {
                                    dragleave: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleDragLeave($event)
                                    },
                                    drop: function($event) {
                                      $event.preventDefault()
                                      return _vm.handleDrop($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.labelDrag) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.email.content,
                  callback: function($$v) {
                    _vm.$set(_vm.email, "content", $$v)
                  },
                  expression: "email.content"
                }
              }),
              _vm._v(" "),
              _vm.expanded && !_vm.forward && !_vm.sending_type
                ? [
                    _c(
                      "CompassTooltip",
                      {
                        attrs: {
                          content: _vm.$t.__(
                            "email.EmailConsultPanelEditor.display_conversation"
                          ),
                          placement: "right"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "conversation-action",
                            on: { click: _vm.expandReplyText }
                          },
                          _vm._l(3, function(dot) {
                            return _c("span", { key: dot, staticClass: "dot" })
                          }),
                          0
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.attachments.length
                ? _vm._l(_vm.attachments, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "attachments-wrapper" },
                      [
                        _c("EmailAttachments", {
                          attrs: { canBeDownloaded: "", attachment: item },
                          on: { removeItem: _vm.removeAttachment }
                        })
                      ],
                      1
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.richTextEditor
                ? _c(
                    "RichTextMenu",
                    {
                      staticClass: "email-richtext-menu",
                      attrs: {
                        editorMenu: _vm.richTextEditor,
                        options: _vm.optionsRichText,
                        typeRichText: "email",
                        disabled: _vm.isPanelMinimized,
                        hash: _vm.hash
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "actions" },
                        [
                          !_vm.isReceivedTable && !_vm.isSentTable
                            ? _c("EmailCustomTemplateToolbar", {
                                attrs: {
                                  hashPanel: _vm.hashPanel,
                                  typePanel: "consultPanel"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "email-consult-editor__footer" }, [
        _vm.showHint
          ? _c("div", {
              staticClass:
                "email-consult-editor__ai-hint typographies-paragraph-small-regular",
              domProps: { innerHTML: _vm._s(_vm.$t.__("richtext.ai.hint")) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "email-consult-editor__actions" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.delete"),
                type: "secondary"
              },
              on: { click: _vm.handleDelete }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.send"),
                loading: _vm.isLoading
              },
              on: { click: _vm.sendEmail }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }